export default {
  firebase: {
    apiKey: 'AIzaSyB4WFXyx8WrUOUO_XQKnOiSRtab_AIGSTI',
    authDomain: 'foxfox-honda.firebaseapp.com',
    databaseURL: 'https://foxfox-honda.firebaseio.com',
    projectId: 'foxfox-honda',
    storageBucket: 'foxfox-honda.appspot.com',
    messagingSenderId: '963425052809'
  }
}



// WEBPACK FOOTER //
// ./src/firebase/credentials.js